export default "__VITE_ASSET__BiH4iIKq__"